import * as React from 'react'
import Styles from './Toast.module.scss'
import cx from 'classnames'

export const Toast = ({
  children,
  className,
  position,
}: {
  children: React.ReactNode
  className?: string
  position: 'top' | 'right' | 'bottomLeft'
}) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return <div className={cx(Styles.container, className!, { [Styles[position]]: true })}>{children}</div>
}
